var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultipleQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.77807 24.7487L-0.000103474 16.9706L7.77807 9.19239L15.5562 16.9706L7.77807 24.7487ZM16.9705 33.9411L9.19228 26.163L16.9705 18.3848L24.7486 26.163L16.9705 33.9411ZM16.9705 15.5563L9.19228 7.77817L16.9705 0L24.7486 7.77817L16.9705 15.5563ZM26.1628 24.7487L18.3847 16.9706L26.1628 9.19239L33.941 16.9706L26.1628 24.7487Z",
    fill: "#2549E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleQr);
export default __webpack_public_path__ + "static/media/multipleQR.4c5a508fe6f2a2d76d68a02a88391758.svg";
export { ForwardRef as ReactComponent };